import { Kana, MailAddress, NotIncludeCsvSeparator, NumberIdentity, PostalCode, Prefecture, TelephoneNumber, Version, } from "@ascend-ltd/logic-helpers";
import { z } from "zod/v4";
const OfficeIdSchema = NumberIdentity.schema.brand();
export const OfficeId = {
    schema: OfficeIdSchema,
};
const OfficeNameSchema = z
    .object({
    name: NotIncludeCsvSeparator.schema.and(z.string().min(1).max(32)),
    kana: Kana.schema.and(z.string().min(1).max(32)),
})
    .brand();
export const OfficeName = {
    schema: OfficeNameSchema,
};
const OfficeAddressSchema = z
    .object({
    prefecture: Prefecture.schema.optional(),
    address1: z.string().optional(),
    address2: z.string().optional(),
})
    .brand();
const OfficeEntitySchema = z.object({
    id: OfficeIdSchema,
    name: OfficeNameSchema,
    postalCode: PostalCode.schema.optional(),
    address: OfficeAddressSchema.optional(),
    telephoneNumber: TelephoneNumber.schema.optional(),
    faxNumber: TelephoneNumber.schema.optional(),
    mailAddress: MailAddress.schema.optional(),
    version: Version.schema,
});
const create = (args) => {
    const values = {
        id: NumberIdentity.generate(),
        version: Version.initial(),
        ...args,
    };
    return OfficeEntity.schema.parse(values);
};
const update = (entity, args) => {
    const next = {
        ...entity,
        name: {
            name: args.name.name,
            kana: args.name.kana,
        },
        postalCode: args.postalCode,
        address: {
            prefecture: args.address?.prefecture,
            address1: args.address?.address1,
            address2: args.address?.address2,
        },
        telephoneNumber: args.telephoneNumber,
        faxNumber: args.faxNumber,
        mailAddress: args.mailAddress,
    };
    return OfficeEntity.schema.parse(next);
};
export const OfficeEntity = {
    schema: OfficeEntitySchema,
    reconstruct: (args) => OfficeEntity.schema.parse(args),
    create,
    update,
};
//# sourceMappingURL=office-entity.js.map